import React, { useRef } from 'react';
import { ToDoItemDescriptionWrapper, BadgeWrapper, BadgeWrapperForNonList } from '../styles';
import { ActionItem } from '../models';
import { Glyphicon, OverlayTrigger } from 'react-bootstrap';
import ListType from '../list-type';

interface IProps {
    description: string,
    list: ListType[],
    isList: boolean,
    highlight?: string,
    color?: string,
    actionItem?: ActionItem,
    title?: string,
    overlay?: any,
    onItemClick: (list: ListType[], action: ActionItem) => void
}

export default (props: IProps) => {
    const myref = useRef(null);

    const handleItemClick = () => {
        if (props.list.length > 0) {
            props.onItemClick(props.list, props.actionItem);
        }
    };

    const backgroundColor = props.list.length == 0 ? "#ccc" : props.highlight;
    const border = props.list.length == 0 ? "1px solid #ccc" : "1px solid #a1a1a1";
    const color = props.color ? (props.list.length > 0 ? props.color : "white") : "white";
    const title = props.title != null ? props.title : "";
    const badgeText = props.actionItem == ActionItem.StagnantMicrositeUpdates && props.list.length > 20 ? "21+" : props.list.length;

    return (
        <div style={{ display: "flex", alignItems: "center" }} title={title}>
            <div style={{ flexBasis: "11%", marginRight: 10, display: "flex", justifyContent: "center" }}>
                {props.isList ?
                    <BadgeWrapper style={{ backgroundColor, color, border }}>{badgeText}</BadgeWrapper>
                    :
                    <BadgeWrapperForNonList style={{ backgroundColor, color, border }}><Glyphicon glyph='question-sign' /></BadgeWrapperForNonList>
                }
            </div>
            {props.overlay == null && (
                <ToDoItemDescriptionWrapper isDisabled={props.list.length == 0} onClick={handleItemClick}>
                    {props.description}
                </ToDoItemDescriptionWrapper>
            )}

            {props.overlay != null && (
                <ToDoItemDescriptionWrapper isDisabled={props.list.length == 0}>
                    <OverlayTrigger container={myref.current} placement='top' trigger={['click', 'click']} rootClose overlay={props.overlay}>
                        <div ref={myref}>{props.description}</div>
                    </OverlayTrigger>
                </ToDoItemDescriptionWrapper>
            )}
        </div>
    );
}
